import { render, staticRenderFns } from "./CreateOnBoarding.vue?vue&type=template&id=5237ec2a&scoped=true&"
import script from "./CreateOnBoarding.vue?vue&type=script&lang=ts&"
export * from "./CreateOnBoarding.vue?vue&type=script&lang=ts&"
import style0 from "./CreateOnBoarding.vue?vue&type=style&index=0&id=5237ec2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237ec2a",
  null
  
)

export default component.exports